import styled from 'styled-components'
import colors from 'configuration/colors'
import _ParagraphIcon from 'static/images/icons/paragraph_icon.svg'

export const ParagraphIcon = styled.img.attrs({
  src: _ParagraphIcon
})`
  width: 9px;
  height: 11px;
`

export const SendAnnouncementForm = styled.div`
  min-height: 173px;
  width: 670px;
  padding: 18px;
  margin-top: 10px;
  border-radius: 7px;
  background-color: ${colors.offwhite};
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.15);
`

export const AnnouncementItemCard = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  height: auto;
  width: 669px;
  padding: 12px 14px;
  margin-bottom: 7px;
  border: 1px solid #dedfe0;
  border-radius: 7px;
  background-color: #ffffff;

  .MuiIconButton-root {
    padding: 0 !important;
    background: transparent !important;
  }

  .oe-elapsed-time {
    display: inline;
  }
`

const ButtonMinimal = styled.button`
  background: transparent;
  font-size: 16px;
  font-family: 'Lato', serif;
  font-weight: 700;
`

const Button = styled(ButtonMinimal)`
  min-width: 100px;
  padding: 7px 25px;
  margin-left: 15px;
  border-radius: 20px;
  color: ${colors.charcoal4};
`

export const CancelButton = styled(Button)`
  margin: 0 12px 0 20px;
  border: 1px solid ${colors.aluminum};
`

export const EditorWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: 14px 17px 30px;
  margin-bottom: 16px;
  min-height: 94px;
  background: ${colors.white};
  border-radius: 7px;
  border: 1px solid ${colors.rock};
  z-index: ${props => (props.focus ? '20' : '0')};

  .DraftEditor-root {
    cursor: text;
  }
`
